import styled from 'styled-components'
import { breakPoints, breakPointsCss, colors } from '../utils/config'
import { Button, Icon } from '@bm-js/atlascloud-ui'
import {
  CustomerUserBM,
  LucideIconName,
  parseDateTime,
} from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

const StyledCustomerUserCard = styled.div`
  padding: 0.5rem;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  position: relative;
  align-items: center;
  &:after {
    position: absolute;
    content: '';
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 1px;
    background: ${colors.blackAlpla300};
  }
  .user-col {
    p {
      color: ${colors.gray700};
    }
  }
  ${breakPointsCss.tablet} {
    grid-template-columns: 1fr auto;
    .last-login {
      display: none;
    }
  }
`

type Props = {
  user: CustomerUserBM
  deleteUser: () => void
  editUserInit: () => void
}

const CustomerUserCard = ({ user, deleteUser, editUserInit }: Props) => {
  const tablet = window.innerWidth < breakPoints.tablet
  const { tr } = useTr()

  return (
    <StyledCustomerUserCard>
      <div className='user-col'>
        <p className='m0 b'>{user.fullName}</p>
        <p className='m0 '>{user.email}</p>
      </div>
      <div className='user-col last-login'>
        <p className='m0 b'>{tr(TrKey.usersLastLogin)}</p>
        <p className='m0'>{parseDateTime(user.lastLogin)}</p>
      </div>
      <div className='user-col jsfe gap1 flex'>
        <Button onClick={editUserInit} withIcon={tablet}>
          {tablet ? (
            <Icon name={LucideIconName.Pen} className='size-5' />
          ) : (
            tr(TrKey.edit)
          )}
        </Button>
        <Button danger onClick={deleteUser} withIcon={tablet}>
          {tablet ? (
            <Icon name={LucideIconName.Trash2} className='size-5' />
          ) : (
            tr(TrKey.delete)
          )}
        </Button>
      </div>
    </StyledCustomerUserCard>
  )
}

export default CustomerUserCard
